import { Injectable } from '@angular/core';
import { DialogOptions } from '@examdojo/core/dialog';
import { ReferenceQuestionStoreModel } from '@examdojo/reference-question';
import { QuestionType } from '../review-item/review-item.model';
import { GenericQuestionHistoryDialogService } from './generic-question-history-dialog.service';

export interface ReferenceQuestionHistoryDialogInput {
  referenceQuestionId: ReferenceQuestionStoreModel['id'];
}

@Injectable({
  providedIn: 'root',
})
export class ReferenceQuestionHistoryDialogService {
  constructor(private readonly genericHistoryDialogService: GenericQuestionHistoryDialogService) {}

  openDialog({ input, options }: { input: ReferenceQuestionHistoryDialogInput; options?: DialogOptions }) {
    return this.genericHistoryDialogService.openDialog({
      input: {
        config: {
          questionId: input.referenceQuestionId,
          questionType: QuestionType.Reference,
          title: 'Reference Question History',
        },
      },
      options,
    });
  }
}
